export default "__VITE_ASSET__35ab9a82__"